import { render } from "./BackerCenterProjectsTabs.vue?vue&type=template&id=a90042f4"
import script from "./BackerCenterProjectsTabs.vue?vue&type=script&lang=js"
export * from "./BackerCenterProjectsTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__